import type { Theme } from '@mui/material/styles';

const getMuiBadge = () => ({
  styleOverrides: {
    root: {
      '& svg': {
        width: 24,
        height: 24,
      },
    },

    badge: ({ theme }: { theme: Theme }) => ({
      '&.MuiBadge-standard': {
        minWidth: '16px',
        minHeight: '16px',
        width: 'fit-content',
        fontSize: '12px',
        fontWeight: 800,
      },
      '&.MuiBadge-colorWarning': {
        backgroundColor: theme.palette.semantic.ui.warning,
      },
      '&.MuiBadge-colorSuccess': {
        backgroundColor: theme.palette.semantic.ui.positive,
      },
      '&.MuiBadge-colorSecondary': {
        backgroundColor: theme.palette.semantic.surface.border,
        color: theme.palette.semantic.text.primary,
      },
      '& svg': {
        width: 12,
        height: 12,
      },
    }),
  },
});
export default getMuiBadge;
